// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3-eZb","itemHead":"index_itemHead_3p4Tv","itemPic":"index_itemPic_1_Ri_"};